<!--
  The subtitle in a page, with styling and an anchor
-->

<template>
  <h3 class="design-subtitle" v-id="id">
    <router-link v-if="id" replace
      :to="{query: $route.query, hash: '#' + id}"
      :tabindex="-1">
      <i class="el-icon-link"></i>
    </router-link>
    <span class="design-subtitle-title">
      <slot>{{title}}</slot>
    </span>
    <tooltip-icon v-if="tooltip || $slots.tooltip"
      v-bind="$attrs" :placement="placement">
      <slot name="tooltip">{{ tooltip }}</slot>
    </tooltip-icon>
  </h3>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    id: String,
    title: String,
    tooltip: String,
    placement: {
      type: String,
      default: 'top',
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  h3.design-subtitle{
    border-bottom: 2px #ebebeb solid;
    padding: 11px 0;
    font-size: 18px;
    line-height: 1;
    span.design-subtitle-title {
      padding-bottom: 8px;
      border-bottom: 2px solid #e92d00;
    }
    i.el-tooltip {
      margin-left: 5px;
    }
    i.el-icon-link {
      margin-right: 5px;
      color: $--color-info;
    }
  }
</style>
